<ng-container *ngIf="(callState$ | async) as state">
  <div class="active-call-bar" *ngIf="state.status !== 'idle'">

    <div class="active-bar-info">
      <img [src]="getProfileImage(getRemoteUser(state))" class="active-bar-avatar" />
      <div class="active-bar-text">
        <span class="active-bar-name">{{ getRemoteUser(state)?.name || 'Contact' }}</span>
        <span class="active-bar-status">{{ statusText }}</span>
      </div>
    </div>

    <div class="active-bar-actions">
      <button class="active-btn mute" (click)="toggleAudio()" [class.on]="audioMuted">
        <span class="material-symbols-outlined">{{ audioMuted ? 'mic_off' : 'mic' }}</span>
        {{ audioMuted ? 'Unmute' : 'Mute' }}
      </button>
      <button class="active-btn video" (click)="toggleVideo()" [class.on]="videoMuted" *ngIf="phase === 'active'">
        <span class="material-symbols-outlined">{{ videoMuted ? 'videocam_off' : 'videocam' }}</span>
        {{ videoMuted ? 'No Video' : 'Video' }}
      </button>
      <button class="active-btn end" (click)="hangUp()">
        <span class="material-symbols-outlined">call_end</span> End
      </button>
    </div>

  </div>

  <!-- Video containers for FaceTime -->
  <div class="facetime-overlay" *ngIf="state.status === 'active' && activeType === 'video'">
    <div id="agora_remote_main" class="video-remote"></div>
    <div id="agora_local" class="video-local"></div>
  </div>

</ng-container>